import { BLANK_FILL_TXT, BLANK_FILL_SELECT } from '@/store/common/constants';
import { APP_CONFIG } from '@/utils/constants'
// import * as MathJax from 'mathjax'

export const replaceHtmlMathlive = (data) => {
    let re2 = new RegExp("\\\\", "g");
    let reLeft = new RegExp("\\\\mleft.", "g");
    let reRight = new RegExp("\\\\mright.", "g");
    let nullTxt = new RegExp("null", "g");
    let ampTxt = new RegExp("amp;", "g");
    let placeTxt = new RegExp("\\\\placeholder", "g");
    let html = data.replace(reLeft, "");
    html = html.replace(reRight, "");
    html = html.replace(nullTxt, "");
    html = html.replace(ampTxt, "");
    html = html.replace(placeTxt, "...");
    html = html.replace('\\mleft', "");
    html = html.replace('\\mright', "");
    html = html.replace('\\mright|', "");
    // html = html.replace('amp;',"");
    html = html.replace(re2, "\\");
    return html;
}

export const compareArray = (arr1, arr2) => {
    if (arr1.length != arr2.length) {
        return false;
    } else {
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] != arr2[i]) return false;
            return true;
        }
    }
}

export const setAlignImgEditor = (data, Delta, type) => {
    let quill = data.quill;
    quill.updateContents(new Delta()
        .retain(data.index)
        .delete(data.length)
        .insert({
            image: data.data.insert.image
        }, {
            alt: `pull-${type}`,
            nameClass: `pull-${type}`
        })
    );
}

export const fillBlankEditor = (type, editorCurr) => {
    // let quill = editorCurr
    // let index = quill.getSelection() ? quill.getSelection().index : 0;
    let html = type === 'select' ? BLANK_FILL_SELECT : BLANK_FILL_TXT;
    CKEDITOR.instances[editorCurr].insertHtml(html);
    // let lengthHtml = html.length;
    // quill.insertText(index, html)
    // quill.setSelection(index + (lengthHtml + 1))
}

export const convertOldKatexData2Img = (val) => {
    let contentEdit = val;
    // console.log('content edit: ', contentEdit);
    let strStartMath = '<span class="ql-formula"';
    let strEndMath = '</span></span></span></span></span>﻿</span>';
    // let strEndMath = '<span class="mclose nulldelimiter"></span></span></span></span></span></span>﻿</span>';
    // let strEndMathDot = '<span class="mclose nulldelimiter"></span></span><span class="mord">.</span></span></span></span></span>﻿</span>';
    // let strEndMathSemiColon = '<span class="mclose nulldelimiter"></span></span><span class="mpunct">;</span></span></span></span></span>﻿</span>';
    let lengthStrEndMath = strEndMath.length;
    // let lengthStrEndMathDot = strEndMathDot.length;
    // let lengthStrEndMathSemiColon = strEndMathSemiColon.length;
    let lengthMathInStr = (contentEdit.match(new RegExp(strStartMath, "g")) || []).length;
    // console.log('Length: ', lengthMathInStr);
    if (lengthMathInStr) {
        let arrString = contentEdit.split(strStartMath);

        // console.log('Arr str: ', arrString);
        let imgMath = [];
        // Setup img math
        arrString.length > 0 && arrString.map((str, index) => {
                let indexData = str.indexOf('">﻿<span contenteditable="false">')
                    // console.log('Index data: ', indexData);
                let data;
                if (indexData > -1) {
                    data = str.substring(1, indexData);
                    data = data.replace('data-value="', '');
                    // console.log('Data: ', data);
                    imgMath.push(`<img align="middle" src="https://math.now.sh?inline=${data}" />&color=black`);
                }
            })
            // Replace all math to img
        for (let i = 0; i < lengthMathInStr; i++) {
            let indexStartMathViaPosition = contentEdit.indexOf(strStartMath);
            let indexEndMathViaPosition = contentEdit.indexOf(strEndMath);
            // let indexEndMathDotViaPosition = contentEdit.indexOf(strEndMathDot);
            // let indexEndMathSemiColonViaPosition = contentEdit.indexOf(strEndMathSemiColon);
            let contentMath;
            if (indexEndMathViaPosition > -1) {
                contentMath = contentEdit.substring(indexStartMathViaPosition, indexEndMathViaPosition + lengthStrEndMath);
            }
            // else if(indexEndMathSemiColonViaPosition > -1) {
            // 	contentMath = contentEdit.substring(indexStartMathViaPosition, indexEndMathSemiColonViaPosition + lengthStrEndMath);
            // } else {
            // 	contentMath = contentEdit.substring(indexStartMathViaPosition, indexEndMathDotViaPosition + lengthStrEndMathDot);
            // }
            contentEdit = contentEdit.replace(contentMath, imgMath[i]);
        }
    }

    return contentEdit;
}

export const tex2img = (formula) => {
    MathJax.Hub.Queue(function() {
        var wrapper = MathJax.HTML.Element("span", {}, formula);
        MathJax.Hub.Typeset(wrapper, function() {
            var svg = wrapper.getElementsByTagName("svg")[0];
            svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
            var image = new Image();
            image.src = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(svg.outerHTML)));
            image.onload = function() {
                var canvas = document.createElement('canvas');
                canvas.width = image.width;
                canvas.height = image.height;
                var context = canvas.getContext('2d');
                context.drawImage(image, 0, 0);
                var img = '<img src="' + canvas.toDataURL('image/png') + '"/>';
                return img;
            };
        });
    })
}

export const throttleFunction = (func, wait, options) => {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function() {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
};

export const throttleTime = (callback, delay = 1000) => {
    // Create a closure around these variables.
    // They will be shared among all events handled by the throttle.
    let throttleTimeout = null;
    let storedEvent = null;

    // This is the function that will handle events and throttle callbacks when the throttle is active.
    const throttledEventHandler = event => {
        // Update the stored event every iteration
        storedEvent = event;

        // We execute the callback with our event if our throttle is not active
        const shouldHandleEvent = !throttleTimeout;

        // If there isn't a throttle active, we execute the callback and create a new throttle.
        if (shouldHandleEvent) {
            // Handle our event
            callback(storedEvent);

            // Since we have used our stored event, we null it out.
            storedEvent = null;

            // Create a new throttle by setting a timeout to prevent handling events during the delay.
            // Once the timeout finishes, we execute our throttle if we have a stored event.
            throttleTimeout = setTimeout(() => {
                // We immediately null out the throttleTimeout since the throttle time has expired.
                throttleTimeout = null;

                // If we have a stored event, recursively call this function.
                // The recursion is what allows us to run continusously while events are present.
                // If events stop coming in, our throttle will end. It will then execute immediately if a new event ever comes.
                if (storedEvent) {
                    // Since our timeout finishes:
                    // 1. This recursive call will execute `callback` immediately since throttleTimeout is now null
                    // 2. It will restart the throttle timer, allowing us to repeat the throttle process
                    throttledEventHandler(storedEvent);
                }
            }, delay);
        }
    };
    // Return our throttled event handler as a closure
    return throttledEventHandler;
};

export const sortDataByOrder = (data) => {
    return data.sort(function(a, b) {
        // return a.order_no - b.order_no;
        return a.orderNo - b.orderNo;
    });
}


export const scrollTo = (element, to, duration) => {
    var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;

    var animateScroll = function() {
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

//t = current time //b = start value //c = change in value //d = duration
Math.easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};


export const isPdf = (link) => {
    let regexCheckPdf = new RegExp("^.*\.(pdf|PDF)$");
    return link.match(regexCheckPdf);
}
export const isWord = (link) => {
    let regexCheckDoc = new RegExp("^.*\.(doc|docx|DOC|DOCX)$");
    return link.match(regexCheckDoc);
}
export const isPowerpoint = (link) => {
    let regexCheckPpt = new RegExp("^.*\.(ppt|pptx|PPT|PPTX)$");
    return link.match(regexCheckPpt);
}
export const isVideo = (link) => {
    let regexCheckVideo = new RegExp("^.*\.(webm|mp4|m4p|m4v|flv|mkv|vob|ogv|ogg|drc|avi|mpg|mpeg|mpe|mpv)$");
    return link.match(regexCheckVideo);
}

export const isImage = (link) => {
    let regexCheckImg = new RegExp("^.*\.(jpg|JPG|JPEG|png|PNG|gif|GIF)$");
    return link.match(regexCheckImg);
}

export const isGifImage = (link) => {
    let regexCheckImg = new RegExp("^.*\.(gif|GIF)$");
    return link.match(regexCheckImg);
}

export const isAudio = (link) => {
    let regexCheckAudio = new RegExp("^.*\.(mp3|MP3|ogg|OGG|WAV|wav)$");
    return link.match(regexCheckAudio);
}

export const isZip = (link) => {
    let regexCheckZip = new RegExp("^.*\.(zip|ZIP)$");
    return link.match(regexCheckZip);
}

export const getNameIcomImg = (link, isGroup = false) => {
    if (isGroup) {
        return 'nhom-hoc-lieu'
    } else if (isGifImage(link)) {
        return 'gif'
    } else if (isImage(link)) {
        return 'image'
    } else if (isAudio(link)) {
        return 'audio'
    } else {
        return 'play'
    }
}

export const generateThumbnailFromVideo = (video) => {
    // var canvas = document.createElement("canvas");
    // // var container = document.getElementById("thumbnail-container");
    // var width = 340;
    // var height = 192;
    // // canvas.width = (width / 3);
    // canvas.width = width;
    // canvas.height = height;
    // canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
    // var image = document.createElement("img");
    // image.src = canvas.toDataURL();
    // return image; 
}

export const stripHtml = (html) => {
    var tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText;
}

export const debounceFunc = (func, wait, immediate) => {
    let timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
};

export const callTimeDiff = (startTime) => {
    let oneMinute = 60
    let endTime = new Date()
    let timeDiff = endTime - startTime //in ms
        // strip the ms
    timeDiff /= 1000

    // get seconds 
    let totalTime = Math.round(timeDiff)
    let minute = Math.floor(totalTime / oneMinute)
    let seconds = totalTime % oneMinute
        // add time continute
        // minute = this.examInfo.totalTime ? parseInt(this.examInfo.totalTime) + minute : minute
    return { minute, seconds }
}

export const replaceImageResize = (link, size) => {
    let result = APP_CONFIG.cdnLive + link.replace('Content//images','images')
    let extention = result.substring(result.length - 4, result.length)
    // console.log('Replace: ', result.substring(result.length - 4, result.length))
    return result.replace('Uploads', 'uploads').replace(extention, `_size_${size.width}_${size.height}${extention}`)
}